import $ from 'jquery';

class AnshinItemAccordion {
  constructor() {
    this.SLIDE_SPEED_MS = 400;
    this.ACCORDION_OPEN_CLASS = 'is-open';

    this.$accordionBtns = $('.js-anshin-accordion-btn');

    this.addEvent();
  }

  addEvent() {
    this.$accordionBtns.each((i, el) => {
      const $target = $(el).parent().find('.c-block-terms__detail');

      let isOpen = false;

      $target.css({
        display: 'none',
        height: $target.outerHeight(),
      });

      $(el).on('click', () => {
        if (isOpen) {
          isOpen = false;

          $(el).removeClass(this.ACCORDION_OPEN_CLASS);
          $target.stop(false, false).slideUp(this.SLIDE_SPEED_MS);
        } else {
          isOpen = true;

          $(el).addClass(this.ACCORDION_OPEN_CLASS);
          $target.stop(false, false).slideDown(this.SLIDE_SPEED_MS);
        }
      });
    })
  }
}

export default AnshinItemAccordion;
